var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.201,
    height: 17.725,
    viewBox: "0 0 25.201 17.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60399",
    "data-name": "Path 60399",
    d: "M793.815,2841.722a5.451,5.451,0,0,0-1-2.5,3.605,3.605,0,0,0-2.525-1.068c-3.526-.255-8.816-.255-8.816-.255h-.011s-5.29,0-8.816.255a3.606,3.606,0,0,0-2.525,1.068,5.45,5.45,0,0,0-1,2.5,38.113,38.113,0,0,0-.252,4.079v1.912a38.113,38.113,0,0,0,.252,4.079,5.452,5.452,0,0,0,1,2.5,4.275,4.275,0,0,0,2.779,1.077c2.016.193,8.568.253,8.568.253s5.3-.008,8.822-.263a3.607,3.607,0,0,0,2.525-1.067,5.452,5.452,0,0,0,1-2.5,38.158,38.158,0,0,0,.252-4.079V2845.8A38.158,38.158,0,0,0,793.815,2841.722Zm-14.952,8.308v-7.081l6.809,3.553Z",
    transform: "translate(-768.866 -2837.898)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.907,
    cy: 0.093,
    r: 1.152,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393939"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48410",
    "data-name": "Group 48410",
    clipPath: "url(#clip-path-youtube)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(-8.4 -12.138)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACK"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15549",
    "data-name": "Rectangle 15549",
    width: 42.002,
    height: 42.001,
    rx: 21.001,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15550",
    "data-name": "Rectangle 15550",
    width: 42.002,
    height: 42.001,
    rx: 21.001,
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "COLOR"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15551",
    "data-name": "Rectangle 15551",
    width: 42.002,
    height: 42.001,
    rx: 21.001,
    fill: "#e52d27",
    style: {
      mixBlendMode: "color",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15552",
    "data-name": "Rectangle 15552",
    width: 42.002,
    height: 42.001,
    rx: 21.001,
    fill: "#e52d27",
    opacity: 0.6,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ac046108d71fc1998ce4e902defcba6b.svg";
export { ForwardRef as ReactComponent };